import { renderServiceBlocks, renderDataElementsBlocks, renderCustomBlocks } from "../renderCreatedBlocks";

const handleBlocksTabPanel = (editor, selectedProject) => {
    if (selectedProject > -1) {
        editor.on('run:show-tabs-panel', () => {
          renderServiceBlocks(editor, selectedProject);
          renderDataElementsBlocks(editor, selectedProject);
          renderCustomBlocks(editor,selectedProject);
        });
        editor.on('load', () => {
          editor.runCommand('show-tabs-panel');
        });
      }
}

export default handleBlocksTabPanel;